import { FirestoreDataConverter } from "firebase/firestore";
import { map } from "lodash";
import moment from "moment";
import Posicao from "../models/posicao";
import PosicaoAtivo from "../models/posicaoAtivo";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class PosicaoDb extends BaseDb<
  Posicao,
  { usuarioId: string; posicaoId: string }
> {
  _path: string = "usuarios/usuarioId/posicoes/posicaoId";
  getConverter(): FirestoreDataConverter<Posicao> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Posicao({
          data: moment(snapshot.get("data").toDate()),
          posicoes: map(snapshot.get("posicoes"), PosicaoAtivo.fromFirestore),
        }),
      toFirestore: toFirestore,
    };
  }
}
